import { render } from "./ThreeSectionsLayout.vue?vue&type=template&id=71eb1e08"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__